/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useAuth } from "cms/auth/hooks/use-auth";
import { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isGuid } from "utils/empty-exists";
import { CardsSimpleImage } from "./image";

const CardsSimpleItemDisplay = (props) => {

    const { token } = useAuth();
    const { item } = props || {};
    const {
        heading,
        image: image_guid,
    } = item || {};

    const [image, setImage] = useState();

    useEffect(() => {
        const fetch = async () => {
            if (!image) {
                if (image_guid && isGuid(image_guid)) {
                    const img = await SimpliCityAdminSDK.image.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, image_guid]);

    return (
        <div className='simplicity-cards-simple-item-display'>
            {image &&
                <div className='simplicity-cards-item-image'>
                    <CardsSimpleImage image={image} />
                </div>
            }
            {heading &&
                <div className='simplicity-cards-simple-item-heading'>
                    {heading}
                </div>
            }
        </div>
    );
};

export { CardsSimpleItemDisplay };
